module.exports = __webpack_public_path__ + "img/251107_9_local_support_event_winner.e32c0f56.png";